import React 			from 'react';
import ReactDOM 		from 'react-dom';
import moment 			from 'moment';

import BLComponent		from '../../core/_BLComponent.jsx';

import CrowdNavigation 	from './../common/_CrowdNavigation.jsx';
import CrowdfundingCountdown 	from './../common/_CrowdfundingCountdown.jsx';
import CountdownIntroBlock 	from './../common/_CountdownIntroBlock.jsx';
import SeriesInternalNav from './../common/_SeriesInternalNav.jsx';
import { bdpDateFormat } from './../common/_BDPUtilities.jsx';

import TimelineContent from './_TimelineContent.jsx';
import BDPHeader from '../common/_BDPHeader.jsx';
import WebinarVideo from '../common/_WebinarVideo.jsx';

export default class CrowdSeriesPreAnnouncement extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
		};

		this.series 				= blapp.models.get('listSeries') || [];
		this.seriesNumber 	= parseInt(blapp.util.getUrlInfo(window.location.href).path.split('/')[3].split('-')[1]); 
		this.seriesContent 	= this.series[this.series.findIndex(series => series.idSeries == this.seriesNumber)];
	}

	render() {
		return (
			<React.Fragment>
				{!blapp.config.isDesktopMode() ? <CrowdNavigation page={1}/> : null}
				<BDPHeader series/>
				<SeriesInternalNav classes="bdp-series-main__series-nav-landing"/>
				<div className="main">
					<div className="main__content">
						<section className="bdp-series-upcoming__intro">
							{this.seriesContent.phase == 'PRE_VALIDATION' ? 
								<CountdownIntroBlock series={this.seriesContent}/>
							:
								<React.Fragment>
									<h2 className="bdp-series-main__announcement-title bdp-series-main__announcement-title--finalists-landing">Coming Soon: {this.seriesContent.strName} Palette Launch and Webinar</h2>
									<article className="bdp-series-main__announcement-block">
										<div className="bdp-series-main__announcement-block-content">
											<h1 className="text--xl-title l-margin-bottom">Mark your calendar!</h1>
											<p>We’re accepting submissions from <strong className="text-color--darkestBlue">{bdpDateFormat(this.seriesContent.udtCrowdSourcingStart)} – {bdpDateFormat(this.seriesContent.udtCrowdSourcingEnd)} {new Date(this.seriesContent.udtCrowdSourcingEnd).getFullYear()}</strong>. The best designs have the chance to be {this.seriesContent.strName} sets, so get those ideas flowing!</p>
											<a href={blapp.url2.getCrowdProjectGuidelinesUrl(this.seriesContent.idSeries)} className="btn btn--yellow text--bold bdp-series-main__intro-cta">Learn more<i className="fas fa-long-arrow-right l-margin-left--sm"/></a>
										</div>
										<div className="bdp-series-main__intro-block-graphical-container bdp-series-main__announcement-block-graphical-container">
											<h2 className="text--bold l-margin-bottom--sm">Palette releases in</h2>
											<CrowdfundingCountdown classes="bdp-series-main__clock bdp-series-main__clock--announcement-block" end={this.seriesContent.udtPaletteAdded}/>
										</div>
									</article>
								</React.Fragment>
							}
						</section>
						{this.seriesContent.phase != 'PRE_VALIDATION' && <WebinarVideo/>}
						<TimelineContent type="upcoming"/>
						{this.renderFooter()}
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderFooter() {
		return (
			<article className="bdp-series-main__footer-callout">
				<h2 className="bdp-series-main__footer-callout-title">Become the next Fan Designer.</h2>
				<a href={blapp.url2.getCrowdProjectGuidelinesUrl(this.seriesContent.idSeries)} className="btn btn--yellow text--bold bdp-series-main__footer-callout-cta">Read <span>the BDP {this.seriesContent.strName}</span> Submission Guidelines</a>
			</article>
		);
	}
};